import { toggleModal } from '../../../../core/store/actions/Modal';
import store from '../../../../core/store/configureStore';

export function closeModal() {
    store.dispatch(toggleModal());
}
